import { useState, useRef } from "react";

export default function UploadModal({ onFiles, status, busy, onClose, onManagedImport }) {
  const [dragging, setDragging] = useState(false);
  const dragCounter = useRef(0);
  const inputRef = useRef(null);

  const handleDragEnter = (e) => {
    e.preventDefault();
    dragCounter.current++;
    setDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    dragCounter.current--;
    if (dragCounter.current === 0) setDragging(false);
  };
  const handleDragOver = (e) => { e.preventDefault(); };
  const handleDrop = (e) => {
    e.preventDefault();
    dragCounter.current = 0;
    setDragging(false);
    const files = e.dataTransfer.files;
    e.nativeEvent.__handledByChild = true; // מונע עיבוד כפול ב-App (האירוע מבעבע ל-app-wrapper)
    if (files?.length) onFiles(files);
  };

  const handleChange = (e) => {
    if (e.target.files?.length) onFiles(e.target.files);
    e.target.value = "";
  };

  return (
    <div
      onClick={busy ? undefined : onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 4000,
        background: "rgba(15,23,42,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        direction: "rtl",
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "white", borderRadius: 16,
          padding: 28, width: 440, maxWidth: "90vw",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          display: "flex", flexDirection: "column", gap: 16,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button
            onClick={onClose}
            disabled={busy}
            style={{ background: "transparent", border: "none", fontSize: 18, cursor: busy ? "default" : "pointer", color: "#94a3b8" }}
          >✕</button>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: "#1e293b" }}>טעינת קבצי מסלקה</h3>
        </div>

        {/* Drop zone */}
        <div
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          style={{
            border: `2px dashed ${dragging ? "#4338ca" : "#cbd5e1"}`,
            borderRadius: 12,
            padding: "36px 24px",
            background: dragging ? "#eff6ff" : "#f8fafc",
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            gap: 8, cursor: "default",
            transition: "all 0.15s",
          }}
        >
          <div style={{ fontSize: 44 }}>{dragging ? "📂" : "🗂️"}</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: dragging ? "#4338ca" : "#475569" }}>
            {dragging ? "שחרר כאן" : "גרור קבצי ZIP / DAT לכאן"}
          </div>
          <div style={{ fontSize: 11, color: "#94a3b8" }}>קבצי מסלקה, פניקס (DAT), פרט, תיק מנוהל, כלל (exe) · ניתן לבחור כמה יחד</div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
          <span style={{ fontSize: 11, color: "#94a3b8" }}>או</span>
          <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
        </div>

        <button
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          style={{
            padding: "11px 0", background: busy ? "#a5b4fc" : "#4338ca", color: "white",
            border: "none", borderRadius: 8, cursor: busy ? "wait" : "pointer",
            fontWeight: 700, fontSize: 14,
          }}
        >
          {busy ? "מעבד…" : "בחר קבצים מהמחשב"}
        </button>

        {onManagedImport && (
          <button
            onClick={onManagedImport}
            disabled={busy}
            style={{
              padding: "10px 0", background: "white", color: "#0284c7",
              border: "1.5px solid #0284c7", borderRadius: 8,
              cursor: busy ? "wait" : "pointer", fontWeight: 700, fontSize: 13,
            }}
          >
            📈 ייבוא דוח תיק מנוהל (Excel)
          </button>
        )}

        <input
          ref={inputRef}
          type="file"
          accept=".zip,.exe,.dat,.xml,.arj"
          multiple
          style={{ display: "none" }}
          onChange={handleChange}
        />

        {status && (
          <div
            style={{
              fontSize: 12, padding: "10px 12px", borderRadius: 8,
              background: status.type === "error" ? "#fef2f2" : status.type === "success" ? "#f0fdf4" : "#eff6ff",
              color: status.type === "error" ? "#991b1b" : status.type === "success" ? "#166534" : "#1e40af",
            }}
          >
            <div>
              {status.type === "loading" ? "⏳ " : status.type === "success" ? "✅ " : status.type === "error" ? "⚠️ " : ""}
              {status.msg}
            </div>
            {status.errors?.length > 0 && (
              <ul style={{ margin: "6px 0 0", paddingInlineStart: 18, color: "#b91c1c" }}>
                {status.errors.slice(0, 6).map((er, i) => <li key={i}>{er}</li>)}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
